import type { FC, PropsWithChildren } from 'react';
import { Link } from 'react-router-dom';
import cls from 'classnames';
import { Text } from '../index';
import s from './index.module.scss';

type Props = {
  isUnderline?: boolean;
  to?: string;
  href?: string;
  size: '1' | '2';
  color: '1' | '2' | '3';
  className?: string;
};

const ComponentLink: FC<PropsWithChildren<Props>> = ({
  isUnderline = true,
  to,
  href,
  size = '1',
  color = '1',
  className,
  children
}) => {
  if (to) {
    return (
      <Link to={to} className={cls(className, s.link, { [s.underlineNone]: !isUnderline })}>
        <Text size={size} color={color}>
          {children}
        </Text>
      </Link>
    );
  }

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      className={cls(className, s.link, { [s.underlineNone]: !isUnderline })}
    >
      <Text size={size} color={color}>
        {children}
      </Text>
    </a>
  );
};

export default ComponentLink;
